import React from "react";
import { useEffect } from "react";
export default function CheckoutFailure() {
  useEffect(() => {
      document.title = "Failure | Payment";
    }, []);
  return (
    <div className="App">
      <h1>Payment Failed or Cancelled</h1>
      <p>Your payment was not successful. Please try again.</p>
    </div>
  );
}
